// src/PublicUser/components/BlogHero.jsx
import React from 'react';

const BlogHero = ({ searchTerm, onSearchChange }) => {
  return (
    <section className="ts-blog-hero">
      <div className="ts-blog-hero-content">
        <div className="ts-blog-hero-badge">
          <span className="ts-pulse-dot"></span>
          TechShara Insights
        </div>
        <h3 className="ts-blog-hero-title">
         Stories &  <span className="ts-gradient-text"> Ideas</span>
        </h3>
        <p className="ts-blog-hero-description">
        Explore the latest in technology, AI, cybersecurity, and digital transformation from industry experts.
        </p>
        
        {/* Search Bar */}
        <div className="ts-blog-search-wrapper">
          <div className="ts-blog-search-icon">🔍</div>
          <input
            type="text"
            className="ts-blog-search-input"
            placeholder="Search for tutorials, articles, or topics..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchTerm && (
            <button 
              className="ts-blog-search-clear"
              onClick={() => onSearchChange('')}
            >
              ✕
            </button>
          )}
        </div>
      </div>
      
      {/* Background Effect */}
      <div className="ts-blog-hero-bg">
        <div className="ts-grid-pattern"></div>
        <div className="ts-glow-orb ts-glow-1"></div>
        <div className="ts-glow-orb ts-glow-2"></div>
      </div>
    </section>
  );
};

export default BlogHero;